export default function truncateChar(string, length) {
  
    if (typeof string !== 'string' || typeof length !== 'number') {
      throw new Error('Invalid input: expected a string and a number');
    }
  
    if (string.length > length) {
      return string.slice(0, length) + '...';
    }
  
    return string;
  }
  